var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resource-list"},_vm._l((_vm.resourceList),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.lookOver(item)}}},[_c('img',{attrs:{"src":require('../../../../assets/icon/' +
          _vm.resourceType(item.filePath) +
          '_icon.png'),"alt":""}}),_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(item.title))]),_c('span',{staticClass:"tag-box"},[_vm._v(_vm._s(item.fileType ? item.fileType : "url"))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }